<template>
  <Legacy
    view="invoicing"
    action="manageCredits"
  />
</template>

<script>
import Legacy from '@/components/Application/Legacy'

export default {
  components: {
    Legacy
  },
  data () {
    return {
      title: 'Credits',
      breadcrumb: {
        name: 'Credits',
        route: { name: 'billing-credits' }
      }
    }
  }
}
</script>
